module.exports = __webpack_public_path__ + "static/img_pledge_interview_06-d338dbd7af433c01a8c2f2e543072f79.png";